import React, { useState } from "react";

const TeamCard = ({ member }) => {
  const [active, setActive] = useState(false);

  return (
    <div className="col-lg-4 col-md-6 col-12">
      <div className={`team-card ${active ? "active" : ""}`}>

        <div className="img-wrapper">

          <img
            src={member.image}
            alt={member.name}
          />

          <div className="description-overlay">
            <div className="overlay-content">

              {member.description.map((para, index) => (
                <p key={index}>{para}</p>
              ))}

            </div>
          </div>
        </div>

        <div className="info-bar">

          <div className="info-text">
            <h4 className="name">{member.name}</h4>

            <span className="designation">
              {member.designation}
            </span>
          </div>

          <button
            className="toggle-btn"
            onClick={() => setActive(!active)}
          >
            <i className="fas fa-plus"></i>
          </button>

        </div>
      </div>
    </div>
  );
};

export default TeamCard;